const routeTypes = {
	layout: 'layout',
	route: 'route',
};

export default routeTypes;
